export default __webpack_public_path__ + "static/media/apiary2.5bf9f2c8.jpg";